<template>
    <div class="intro">
        <div class="container intro__content">
            <h2 class="intro__content__title">Bem-vindo ao
                Blog Fibrilare</h2>
            <h3 class="intro__content__subtitle">Fique por dentro de todas
                as tendências do mercado</h3>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BlogIntro"
    }
</script>

<style lang="scss" scoped>
    .intro {
        height: 400px;
        background-image: url('../../../assets/backgrounds/blog-banner.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        position: relative;

        &::after {
            width: 100%;
            height: 100%;
            background-image: linear-gradient(86deg, rgba(86, 86, 86, 0), rgba(32, 32, 32, 0.63) 47%, #000000);
            opacity: 0.9;
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
        }

        &__content {
            color: #fff;

            &__title, &__subtitle {
                max-width: 360px;
            }

            &__title {
                padding-top: 70px;
                font-family: Poppins, Arial, sans-serif;
                font-weight: 500;
                font-size: 2.375rem;
            }

            &__subtitle {
                font-family: "Open Sans";
                font-weight: 500;
                font-size: 1.75rem;
                margin-top: 20px;
            }
        }
    }

    @media only screen and(max-width: 1200px) {
        .intro__content__title {
            font-size: 2rem;
        }

        .intro__content__subtitle {
            font-size: 1.5rem;
        }
    }
</style>